// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.containerHomePage {
  display: flex;
  position: relative;
}

.containerRequest {
  display: flex;
  width: calc(100% - 55px);
  padding: 30px 0px 0px 35px;
  flex-direction: column;
  margin-bottom: 30px;
}

.nullDescription {
  color: #979ea4;
}

.centerText {
  width: 100%;
  text-align: left;
  color: #979ea4;
}

.centerTextBlack {
  color: #000;
}

.titleRequest {
  font-size: 18px;
}

.containerBalls {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.partNumberColluns {
  display: flex;
  padding-left: 20px;
  font-size: 16px;
}

.genericGrid {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0px 50px 100px 35px;
  gap: 12px;
  position: relative;

  .exportBtn{
    display: flex;
    width: 92%;
    justify-content: end;
    position: absolute;
    top: 0;
    left: -42px;
  }
}

.containerGraphs {
  width: 100%;
  padding: 0px 50px 100px 35px;
}

.MuiDataGrid-root .MuiDataGrid-footerContainer {
  border: none !important;
  height: 0px !important;
  background-color: #f9f9f9 !important;
}

.MuiDataGrid-root {
  border: none !important;
  height: 92% !important;
}

.MuiDataGrid-root .MuiDataGrid-filler {
  background-color: #f9f9f9 !important;
  border: none !important;
  height: 0px !important;
}

.buttonImg img {
  width: 22px;
}

.buttonActions {
  margin-top: -15px;
}

.titleAprover {
  font-size: 18px;
  font-weight: 700;
}

div.titleAproverText {
  font-size: 18px;
  font-weight: 400;
  font-family: "Bosch Sans", sans-serif !important;
}

.css-183rme2 {
  display: none !important;
}
.ModalViewDescriptions {
  height: 190px;
}

.containerCards {
  display: flex;
  justify-content: space-between;
}

.title_dash {
  position: absolute;
  border-bottom: 2px solid #ccc;
  width: 100%;
  top: 0;
}

.title_dash h2 {
  color: #000;
  font-weight: 700;
  font-size: 20px;
  margin: 10px;
}

.chartLegendLayout {
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.chartLegendChartArea {
  flex: 1 1 45%;
  min-width: 180px;
  height: 100%;
}

.chartLegendPanel {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-height: 100%;
  padding: 12px 40px 18px 0;
}

.chartLegendList {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 350px;
  padding-right: 8px;
}

.chartLegendItem {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  min-width: 0;
}

.chartLegendDot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  flex: 0 0 12px;
}

.chartLegendLabel {
  font-size: 14px;
  min-width: 0;
  flex: 1 1 auto;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chartLegendValue {
  flex: 0 0 auto;
  font-size: 14px;
}

@media (max-width: 1024px) {
  .chartLegendLayout {
    flex-direction: column;
  }

  .chartLegendChartArea {
    flex: 0 0 52%;
    min-height: 180px;
  }

  .chartLegendPanel {
    flex: 1 1 auto;
    padding: 0 8px 8px;
  }

  .chartLegendList {
    max-height: 120px;
  }
}

@media (max-width: 640px) {
  .chartLegendLabel {
    font-size: 13px;
  }

  .chartLegendValue {
    font-size: 13px;
  }
}

.no_results {
  font-weight: 400;
  font-size: 20px;
  color: #979ea4;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.wrap_text {
  width: 180px;
}

.action-btns{
  width: 20px;
  height: 14px;
  background: none;
  border: none;
  padding: 0px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
}

.iconDownload {
    width: 30px;
    height: 30px;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/componentes/fluxo-tax/Request-tax/RequestTax.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,0BAA0B;EAC1B,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,SAAS;EACT,kBAAkB;;EAElB;IACE,aAAa;IACb,UAAU;IACV,oBAAoB;IACpB,kBAAkB;IAClB,MAAM;IACN,WAAW;EACb;AACF;;AAEA;EACE,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,MAAM;AACR;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB","sourcesContent":[".containerHomePage {\n  display: flex;\n  position: relative;\n}\n\n.containerRequest {\n  display: flex;\n  width: calc(100% - 55px);\n  padding: 30px 0px 0px 35px;\n  flex-direction: column;\n  margin-bottom: 30px;\n}\n\n.nullDescription {\n  color: #979ea4;\n}\n\n.centerText {\n  width: 100%;\n  text-align: left;\n  color: #979ea4;\n}\n\n.centerTextBlack {\n  color: #000;\n}\n\n.titleRequest {\n  font-size: 18px;\n}\n\n.containerBalls {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n\n.partNumberColluns {\n  display: flex;\n  padding-left: 20px;\n  font-size: 16px;\n}\n\n.genericGrid {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  padding: 0px 50px 100px 35px;\n  gap: 12px;\n  position: relative;\n\n  .exportBtn{\n    display: flex;\n    width: 92%;\n    justify-content: end;\n    position: absolute;\n    top: 0;\n    left: -42px;\n  }\n}\n\n.containerGraphs {\n  width: 100%;\n  padding: 0px 50px 100px 35px;\n}\n\n.MuiDataGrid-root .MuiDataGrid-footerContainer {\n  border: none !important;\n  height: 0px !important;\n  background-color: #f9f9f9 !important;\n}\n\n.MuiDataGrid-root {\n  border: none !important;\n  height: 92% !important;\n}\n\n.MuiDataGrid-root .MuiDataGrid-filler {\n  background-color: #f9f9f9 !important;\n  border: none !important;\n  height: 0px !important;\n}\n\n.buttonImg img {\n  width: 22px;\n}\n\n.buttonActions {\n  margin-top: -15px;\n}\n\n.titleAprover {\n  font-size: 18px;\n  font-weight: 700;\n}\n\ndiv.titleAproverText {\n  font-size: 18px;\n  font-weight: 400;\n  font-family: \"Bosch Sans\", sans-serif !important;\n}\n\n.css-183rme2 {\n  display: none !important;\n}\n.ModalViewDescriptions {\n  height: 190px;\n}\n\n.containerCards {\n  display: flex;\n  justify-content: space-between;\n}\n\n.title_dash {\n  position: absolute;\n  border-bottom: 2px solid #ccc;\n  width: 100%;\n  top: 0;\n}\n\n.title_dash h2 {\n  color: #000;\n  font-weight: 700;\n  font-size: 20px;\n  margin: 10px;\n}\n\n.chartLegendLayout {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\n.chartLegendChartArea {\n  flex: 1 1 45%;\n  min-width: 180px;\n  height: 100%;\n}\n\n.chartLegendPanel {\n  flex: 1 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  max-height: 100%;\n  padding: 12px 40px 18px 0;\n}\n\n.chartLegendList {\n  overflow-y: auto;\n  overflow-x: hidden;\n  max-height: 350px;\n  padding-right: 8px;\n}\n\n.chartLegendItem {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n  min-width: 0;\n}\n\n.chartLegendDot {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  flex: 0 0 12px;\n}\n\n.chartLegendLabel {\n  font-size: 14px;\n  min-width: 0;\n  flex: 1 1 auto;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.chartLegendValue {\n  flex: 0 0 auto;\n  font-size: 14px;\n}\n\n@media (max-width: 1024px) {\n  .chartLegendLayout {\n    flex-direction: column;\n  }\n\n  .chartLegendChartArea {\n    flex: 0 0 52%;\n    min-height: 180px;\n  }\n\n  .chartLegendPanel {\n    flex: 1 1 auto;\n    padding: 0 8px 8px;\n  }\n\n  .chartLegendList {\n    max-height: 120px;\n  }\n}\n\n@media (max-width: 640px) {\n  .chartLegendLabel {\n    font-size: 13px;\n  }\n\n  .chartLegendValue {\n    font-size: 13px;\n  }\n}\n\n.no_results {\n  font-weight: 400;\n  font-size: 20px;\n  color: #979ea4;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.wrap_text {\n  width: 180px;\n}\n\n.action-btns{\n  width: 20px;\n  height: 14px;\n  background: none;\n  border: none;\n  padding: 0px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n}\n\n.iconDownload {\n    width: 30px;\n    height: 30px;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
